import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { Button } from "@mui/material";
import "./whatsapp-banner.container.css";
import { Container } from "../../components/container/container";
import { useCallback } from "react";
import { removeMask } from "../../util/mask";

type WhatsappBannerProps = {
  whatsappNumber: string;
};

export function WhatsappBanner({ whatsappNumber }: WhatsappBannerProps) {
  const redirectToWhatsapp = useCallback((number: string) => {
    const phoneNumber = "55" + removeMask(number);

    window.open(
      `https://wa.me/${phoneNumber}?text=Olá! Cheguei aqui pelo Gov.PI Cidadão e gostaria de solicitar atendimento.`,
      "_blank"
    );
  }, []);

  return (
    <div className="xvia-whatsapp-banner__container">
      <Container>
        <section
          className="xvia-whatsapp-banner"
          style={{
            backgroundImage: `url("${process.env.PUBLIC_URL}/images/svgs/bg-whatsapp-banner.svg")`,
            backgroundSize: "cover",
            backgroundPosition: "right end",
            backgroundRepeat: "no-repeat",
          }}
        >
          <div className="xvia-whatsapp-banner__content">
            <div className="xvia-whatsapp-banner__content-left">
              <div className="xvia-whatsapp-banner__content-text-container">
                <div className="xvia-whatsapp-banner__title">
                  O Gov.pi agora está no WhatsApp!
                </div>
                <p className="xvia-whatsapp-banner__content-text">
                  Tudo o que você precisa em um só lugar. Mande um oi e tire
                  suas dúvidas agora mesmo.
                </p>
                <ul className="xvia-whatsapp-banner__list">
                  <li>Consulte serviços públicos</li>
                  <li>Receba seus documentos</li>
                  <li>Agende atendimentos e emita boletos</li>
                </ul>
              </div>
              <div
                className="xvia-whatsapp-banner__content-image-container"
                style={{
                  backgroundImage: `url(${process.env.PUBLIC_URL}/images/svgs/wpp-banner-img.svg)`,
                }}
              ></div>

              <Button
                endIcon={<OpenInNewIcon style={{ fontSize: 20 }} />}
                variant="contained"
                size="small"
                onClick={() => redirectToWhatsapp(whatsappNumber)}
                className="xvia-whatsapp-banner__content-button"
              >
                Iniciar a conversa
              </Button>
            </div>
          </div>
        </section>
      </Container>
    </div>
  );
}
